module.exports = new __parcel__URL__("comments-dark.389695ba.svg").toString();